var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-chat-item-photos",class:_vm.photoClass},_vm._l((_vm.photos),function(photo){return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(photo),expression:"photo"}],key:photo,staticClass:"photo"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }